import { createErrorCodes } from '@shared/utils';
import { CORE_MESSAGES } from './CORE_MESSAGES';

export const CORE_ERROR_CODES = createErrorCodes(CORE_MESSAGES);
